import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readAllTenant } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

function TenantsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [tenants, setTenants] = useState(() => []);
  const [tenantsSelected, setTenantsSelected] = useState([]);
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const convertForDateBr = (dateReceived) => {
    const date = new Date(dateReceived);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    const dateBr = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;

    return `${dateBr} ${time}`;
  };

  // const fetchtenants = async () => {
  //   const tenantsList = await readAllTenant();
  //   if(tenantsList === undefined) setLoading(true);
  //   const elements = tenantsList.map((element) => {
  //     const { pass, transportName, contextName, languageName, busy, captureGroup } = element;
  //     element['password'] = pass;
  //     element['transport'] = transportName;
  //     element['context'] = contextName;
  //     element['language'] = languageName;
  //     element['state'] = busy;
  //     element['pickupGroup'] = captureGroup;

  //     delete element.pass;
  //     delete element.transportName;
  //     delete element.contextName;
  //     delete element.languageName;
  //     delete element.captureGroup;

  //     return element;
  //   }).filter((element) => !isNaN(Number(element.endpoint)));
    
  //   setTenants(elements);
  //   setLoading(false);

  //   return true;
  // };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const tenantsFetched = await readAllTenant();
    if (!tenantsFetched) return;
    setTenants(tenantsFetched);
    setLoading(false);
    return tenantsFetched;
  }, []);

  const handleChangeSelectedTenants = (element) => {
    setTenantsSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true)
      return onlineState;
    });
  };

  const handleClickDelete = async () => {
    // const sendDeletetenants = await exportDeleteEndpoints(tenantsSelected);
    // if(sendDeleteEndpoints.length === undefined) {
    //   toggleIsHidden('#alert-confirm-tenants-delete');
    //   return toggleIsChangeFormElements('alert-tenants-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    // };
    // toggleIsHidden('#alert-confirm-tenants-delete');
    // setDisable(true);
    // toggleIsHidden('#buttons');
    // validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(tenantsSelected);
    return history.push('/config/cliente/id');
  };

  const handleChangeSelectAll = () => {
    const inputSelectAll = document.getElementById('select-all');
    const selectTenants = tenants.map((element) => {
      const getCheckbox = document.getElementById(element.short_name);
      if(inputSelectAll.checked) {
        getCheckbox.checked = true;
        setDisable(false);
        return element.endpoint;
      } else {
        getCheckbox.checked = false;
        setDisable(true);
        return null;
      }
    });
    const result = selectTenants[0] === null ? [] : selectTenants;
    return setTenantsSelected(result);
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">LISTA DE CLIENTES</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-tenants-not-delete" name="alert-tenants-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-tenants-not-delete') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar os ramais selecionados.
            </div>
          </article>
          <article id="alert-confirm-tenants-delete" name="alert-confirm-tenants-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-tenants-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar os ramais selecionados?
            </div>
            <br />
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Confirmar
                    </span>
              </button>
              <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-tenants-delete')
                toggleIsHidden('#buttons')
              }}>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
              </button>
            </div>
          </div>
          </article>
          <article id="alert-create-tenants" name="alert-create-tenants" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-tenants') }></button>
            </div>
            <div className="message-body">
              Ramais deletados com sucesso!
            </div>
          </article>
          <div className="table-container is-flex-wrap-wrap">
            <table id="tableCalls" className="table is-hoverable is-striped is-fullwidth">  
              <thead>
                  <tr className='is-size-7 has-text-centered'>
                  <th className='th-interactive is-clickable' scope="col">
                    <input id="select-all"type="checkbox" onClick={ () => handleChangeSelectAll()}/>
                  </th>
                  <th className='th-interactive is-clickable' scope="col">Nome</th>
                  <th className='th-interactive is-clickable' scope="col">ID/Feixe</th>
                  <th className='th-interactive is-clickable' scope="col">Tempo de Gravação</th>
                  <th className='th-interactive is-clickable' scope="col">Ramais</th>
                  <th className='th-interactive is-clickable' scope="col">Operadora</th>
                  <th className='th-interactive is-clickable' scope="col">Status</th>
                  <th className='th-interactive is-clickable' scope="col">Desde</th>
                  </tr>
              </thead>
              <tbody>
              {
                tenants.map((tenant) => {
                  const { name, short_name, active, endpoints, rec_time, created_at } = tenant;
                  return (
                    <tr className='is-size-7 has-text-centered' key={ short_name }>
                      <td><input id={ short_name } type="checkbox" value={name} onClick={ (e) => handleChangeSelectedTenants(e.target.value)}/></td>
                      <td>{name}</td>
                      <td>{short_name}</td>
                      <td>{rec_time}</td>
                      <td>{endpoints.filter((item) => !isNaN(Number(item.endpoint))).length}</td>
                      <td>{endpoints.map((item) => item.endpoint).filter((item) => isNaN(Number(item)))}</td>
                      {/* <td>{endpoints.length}</td> */}
                      <td>{active ? 'Ativo' : 'Dasativado' }</td>
                      <td>{convertForDateBr(created_at)}</td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
          <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button
                  className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ true }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faPen } fixedWidth />
                      </span>
                      <span>
                        Alterar
                      </span>
                </button>
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-tenants-delete')
                    toggleIsHidden('#buttons')
                    }}
                  // disabled={ disable }
                  
                    disabled={ true }
                >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Deletar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default TenantsList;